__turbopack_context__.v({
  "reactions": "PostsCard-module__41pGLW__reactions",
  "title": "PostsCard-module__41pGLW__title",
});
